import React from 'react';
import FontAwesomeIcon from 'src/components/Icon';
import './checklist-preview.scss';

interface ChecklistPreviewProps {
  items: any[];
}

const ChecklistPreview = ({ items }: ChecklistPreviewProps) => {
  if (!items || items.length === 0) {
    return (
      <div className="checklist_preview_empty">
        No checklist items available for preview.
      </div>
    );
  }

  return (
    <div className="checklist_preview">
      <div className="checklist_preview_summary">
        {items.filter((i) => i.ischecked).length} of {items.length} items completed
      </div>

      <ul className="checklist_preview_list">
        {items.map((item, idx) => (
          <li
            key={item.id || idx}
            className={`checklist_preview_item ${
              item.ischecked ? 'checklist_preview_item_checked' : 'checklist_preview_item_unchecked'
            }`}
          >
            <span className="checklist_preview_icon">
              <FontAwesomeIcon
                glyph={item.ischecked ? 'check-circle' : 'circle'}
                weight={item.ischecked ? 'solid' : 'light'}
                size="small"
              />
            </span>
            <span className="checklist_preview_description">
              {item.description}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ChecklistPreview;